import { render, staticRenderFns } from "./CallHistoryRow.vue?vue&type=template&id=53a6ffa6&scoped=true&"
import script from "./CallHistoryRow.vue?vue&type=script&lang=ts&"
export * from "./CallHistoryRow.vue?vue&type=script&lang=ts&"
import style0 from "./CallHistoryRow.vue?vue&type=style&index=0&id=53a6ffa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a6ffa6",
  null
  
)

export default component.exports